import moment from 'moment'
import { h } from 'preact'
import { useMemo } from 'preact/hooks'
import PropTypes from 'prop-types'

import classNames from 'lib/classNames'
import useUpdateEverySecond from 'lib/useUpdateEverySecond'

// e.g. "September 8, 2025 at 12:23 PM"
const FULL_FORMAT = 'MMMM D, YYYY [at] h:mm A'

export default function TimeAgo({
  className = '',
  time,
  tiny,
  format,
  ...props
}){
  // an absolute date never goes stale, so it has no reason to re-render every
  // second -- and `format` must not fall through to the span as an attribute
  const full = format === 'full'
  useUpdateEverySecond(!full)
  const {title, value} = useMemo(
    () => {
      const timeAsMoment = moment(time)
      const delta = timeAsMoment.diff(moment())
      // showing the absolute date flips which half goes in the tooltip, so
      // the relative reading stays available either way
      const title = full
        ? timeAsMoment.fromNow()
        : timeAsMoment.format('MMM Do YYYY h:mmA')
      const value = full
        ? timeAsMoment.format(FULL_FORMAT)
        : tiny
          ? (delta > -44000) ? `${Math.round(Math.abs(delta) / 1000)}s` : tinyFormat(timeAsMoment.fromNow(), delta)
          : (delta > -2000 ? 'just now' : timeAsMoment.fromNow())
      return {title, value}
    },
    [time, tiny, full]
  )
  return <span {...{
    ...props,
    className: classNames('TimeAgo', { className }),
    title,
  }}>{value}</span>
}

TimeAgo.propTypes = {
  className: PropTypes.string,
  time: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date),
  ]).isRequired,
  tiny: PropTypes.bool,
  format: PropTypes.oneOf(['full']),
}

function tinyFormat(timeAgoString){
  const matches = timeAgoString.toLowerCase().match(/^(\d+|an?)\s+(\w+?)s? ago/)
  if (!matches) return ''
  let [_, int, range] = matches
  if (int === 'a' || int === 'an') int = '1'
  int = parseInt(int, 10)
  if (range === 'month'){
    int *= 4
    range = 'week'
  }
  return `${int}${range[0].toLowerCase()}`
}
